import React from "react";
import { Activity } from "lucide-react";

const PerformanceMetrics = ({ data }: { data: any }) => {
  // Sample data - replace with your actual data
  const recipients = data?.result?.performanceMetrics?.recipients;
  const successful = data?.result?.performanceMetrics?.successful;
  const failed = data?.result?.performanceMetrics?.failed;
  const successRate = data?.result?.performanceMetrics?.successRate;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 max-w-xl">
      {/* Header */}
      <div className="mb-2">
        <div className="flex items-center gap-2 mb-2">
          <Activity className="w-5 h-5 text-green-500" />
          <h2 className="text-xl font-semibold text-gray-900">
            Performance Metrics
          </h2>
        </div>
        <p className="text-sm text-gray-500">
          Workflow execution statistics and success indicators
        </p>
      </div>

      {/* Metrics */}
      <div className="space-y-2">
        {/* Total Executions */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 bg-gray-400 rounded-full"></span>
            <span className="text-gray-700">Recipients</span>
          </div>
          <span className="text-base font-semibold text-gray-900">
            {recipients}
          </span>
        </div>

        {/* Successful */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 bg-gray-400 rounded-full"></span>
            <span className="text-gray-700">Successful</span>
          </div>
          <span className="text-base font-semibold text-green-600">
            {successful}
          </span>
        </div>

        {/* Failed */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 bg-gray-400 rounded-full"></span>
            <span className="text-gray-700">Failed</span>
          </div>
          <span className="text-base font-semibold text-orange-500">
            {failed}
          </span>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-200 my-4"></div>

        {/* Success Rate */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 bg-gray-400 rounded-full"></span>
            <span className="text-gray-700">Success Rate</span>
          </div>
          <span className="text-base font-semibold text-blue-600">
            {successRate}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default PerformanceMetrics;
